module.exports = __webpack_public_path__ + "static/media/CoBorrower.beb87cc1.svg";